import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class CustomMatIconRegistryService {
  constructor(private matIconRegistry: MatIconRegistry, private domSanitizer: DomSanitizer) {}

  private isInitialized = false;

  private readonly iconNameToSoureMappings: { [iconName: string]: string } = {
    ['search-icon']: '/assets/icons/search-icon.svg',
    ['save-icon']: '/assets/icons/save-icon.svg',
    ['saved-icon']: '/assets/icons/saved-icon.svg',
    ['close-icon']: '/assets/icons/close-icon.svg',
    ['share-icon']: '/assets/icons/share-icon.svg',
    ['add-icon']: '/assets/icons/add-icon.svg',
    ['minus-icon']: '/assets/icons/minus-icon.svg',
    ['tooltip-icon']: '/assets/icons/tooltip-icon.svg',
    ['download-icon']: '/assets/icons/download-icon.svg',
    ['send-icon']: '/assets/icons/send-icon.svg',
    ['chevron-down-icon']: '/assets/icons/chevron-down-icon.svg',
    ['computer-icon']: '/assets/icons/computer-icon.svg',
    ['book-icon']: '/assets/icons/book-icon.svg',
    ['graduate-icon']: '/assets/icons/graduate-icon.svg',
    ['users-icon']: '/assets/icons/users-icon.svg',
    ['filter-icon']: '/assets/icons/filter-icon.svg',
    ['check-icon']: '/assets/icons/check-icon.svg',
    ['angle-left-icon']: '/assets/icons/angle-left-icon.svg'
  };

  public init(): void {
    if (this.isInitialized) {
      return;
    }

    Object.keys(this.iconNameToSoureMappings).forEach((iconName) => {
      this.matIconRegistry.addSvgIcon(
        iconName,
        this.domSanitizer.bypassSecurityTrustResourceUrl(this.iconNameToSoureMappings[iconName])
      );
    });

    this.isInitialized = true;
  }
}
